import AnalyticsApi from '../api/AnalyticsApi';
import AnalyticsConstants from '../constants/AnalyticsConstants';

function fetchDataLayer() {
  return {
    types: [
      AnalyticsConstants.FETCH_DATALAYER_REQUEST,
      AnalyticsConstants.FETCH_DATALAYER_SUCCESS,
      AnalyticsConstants.FETCH_DATALAYER_FAILURE
    ],
    apiRequest: (state, client) => AnalyticsApi.fetchDataLayer(client)
  };
}

export default {
  fetchDataLayer
};



// WEBPACK FOOTER //
// ./app/actions/AnalyticsActions.js